import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/system";

import { useTrackingHistory } from "../../../utils/useTrackingHistory";
import { getAccountType, getIsIslamicBanking } from "../../../store/selectors/appConfig";
import { resetApplicantInfo } from "../../../store/actions/appConfig";
import { TwoSteps } from "./TwoSteps";
import { CommonQuestions } from "./CommonQuestions";
import { SectionTitleWithInfo } from "../../../components/SectionTitleWithInfo";
import { ImportantNote } from "../../../components/InfoNote/ImportantNote";
import { ReactComponent as UAEFlag } from "../../../assets/icons/flags/UnitedArabEmirates.svg";
import { questions } from "../constants";
import {
  APPLICATION_APPROVAL_INFO,
  APPLICATION_APPROVAL_MESSAGE,
  APPLICATION_TITLE_MESSAGE,
  CONVENTIONAL,
  ISLAMIC,
  personaSelectionRoutesMap
} from "../../../constants";
import { StyledApplicationOverview, StyledAccordionWrapper, StyledImportantNote } from "./styled";
import { Footer } from "../../../components/Footer";
import { BackLink } from "../../../components/Buttons/BackLink";
import { NextStepButton } from "../../../components/Buttons/NextStepButton";

export const ApplicationOverviewComponent = () => {
  const dispatch = useDispatch();
  const queryParams = useLocation().search;
  const pushHistory = useTrackingHistory();
  const isMobile = useMediaQuery("(max-width: 767px)") || window.innerWidth <= 768;
  const accountType = useSelector(getAccountType);
  const isIslamicBanking = useSelector(getIsIslamicBanking);

  const handleStart = () => {
    dispatch(resetApplicantInfo());
    const url = personaSelectionRoutesMap[accountType][isIslamicBanking ? ISLAMIC : CONVENTIONAL];
    if (queryParams) {
      pushHistory(url + queryParams);
    } else {
      pushHistory(url);
    }
  };

  return (
    <StyledApplicationOverview data-testid="application-overview-component">
      <SectionTitleWithInfo
        smallInfo
        title="Get ready to open your account!"
        info="For a successful application, please ensure you have the following documents."
      />
      <TwoSteps withHeader />
      <StyledImportantNote>
        <ImportantNote
          className={"importantNoteApplicationOverview"}
          noteTitle="Note"
          noteInfo={APPLICATION_APPROVAL_INFO}
          description={APPLICATION_APPROVAL_MESSAGE}
          customIcon={<UAEFlag />}
          heading={APPLICATION_TITLE_MESSAGE}
        />
      </StyledImportantNote>
      <div style={{ marginBottom: !isMobile ? "50px" : 0 }}>
        <StyledAccordionWrapper
          title={"Frequently asked questions"}
          id={"frequently_asked_questions"}
          sx={{ "& .MuiAccordion-root": { borderBottom: "0px" } }}
        >
          <p className={"subTitle"}>
            {"Here are the answers to some things you're probably wondering about"}
          </p>
          <CommonQuestions questions={questions} />
        </StyledAccordionWrapper>
      </div>
      <Footer dataTestId="start-application-btn-section">
        <BackLink path="/" isTypeButton={true} text={isMobile ? "Go back" : "Back"} />
        <NextStepButton
          label={isMobile ? "Let’s start" : "Next"}
          handleClick={handleStart}
          data-testid="startBtn"
          justify="flex-end"
        />
      </Footer>
    </StyledApplicationOverview>
  );
};
